module.exports = __webpack_public_path__ + "img/help4.6756f554.png";